import { Navigate, Route, Routes } from 'react-router-dom';
import ShareLinkRoute from './routes/ShareLinkRoute';
import LandingRoute from './routes/LandingRoute';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/t/:token" element={<ShareLinkRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
